import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity, Evidence, Link, File } from "../../../api/classes";
import { Avatar, Typography, List, GridList } from "@material-ui/core";
import CaseEvidence from "../components/evidence";
import { DubitoSvc } from "../../../api";
import { GetCaseRequest, AddEvidenceRequest } from "../../../api/DubitoAPI";
import axios from "axios";
import FileUpload from "../../../components/fileUpload";
import SendMessageArea from "src/components/sendMessageArea";
import * as classes from "src/api/classes";
import { hasPermissionOf } from "src/auth/auth";
import { Permissions } from "src/api/constants";
import EmptyState from "src/components/emptyState";

interface Props {
  caseId: number;
  evidences: Evidence[];
  style?: React.CSSProperties;
  files: File[];
  links: Link[];
  onUpdate: () => void;
  full?: boolean;
}
class CaseEvidences extends React.Component<Props> {
  state = {
    file: []
  };

  addEvidence = (text, files: classes.File[], callback) => {
    let file_ids = undefined;
    if (files) {
      file_ids = files.map(f => f.id);
    }
    DubitoSvc.addEvidence({
      case_id: this.props.caseId,
      text: text,
      file_ids
    } as AddEvidenceRequest).then(res => {
      //console.log(res);
      this.setState({ text: "" });
      this.props.onUpdate();
      callback();
    });
  };
  handleFileUpload = event => {
    this.setState({ file: event.target.files });
  };

  onDelete = (evidence: Evidence) => {
    DubitoSvc.deleteEvidence({
      case_id: this.props.caseId,
      evidence_id: evidence.id
    }).then(res => {
      this.props.onUpdate();
    });
  };
  render() {
    const { style } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_CASES);

    return (
      <div>
        {canEdit && <SendMessageArea canAttachFile onSend={this.addEvidence} />}
        <GridList cols={this.props.full ? 2 : 1} style={style}>
          {this.props.evidences.length === 0 ? (
            <EmptyState message="There is no evidence yet" />
          ) : (
            this.props.evidences.map(a => {
              return (
                <CaseEvidence
                  key={a.id}
                  style={{ margin: 12, height: "100%", alingSelf: "center" }}
                  evidence={a}
                  files={this.props.files}
                  links={this.props.links}
                  onDelete={canEdit ? this.onDelete : undefined}
                />
              );
            })
          )}
        </GridList>
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseEvidences);



// WEBPACK FOOTER //
// ./src/pages/cases/detail/evidence.tsx